"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const plugin_1 = __importDefault(require("./plugin"));
exports.default = plugin_1.default;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvcGx1Z2lucy9jdXN0b20vZ29vZ2xlVGFnTWFuYWdlckRhdGFJbmplY3Rpb24vaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSxzREFBMkQ7QUFFM0Qsa0JBQWUsZ0JBQW1DLENBQUMifQ==


// WEBPACK FOOTER //
// ../../../../../src/plugins/custom/googleTagManagerDataInjection/index.ts